import React from 'react';
import { confirm } from 'devextreme/ui/dialog';
import { formatId,formatToMoney,formatDate } from '../../utils/common';
import http from '../../utils/http';
import useAuthorization from '../../hooks/useAuthorization';
import { dataAccess, resources } from '../../data/app';
import { billNotifyDialogAction } from '../../store/billNotify/billNotifyDialogReducer';
import { useDispatch } from 'react-redux';
import { billPaymentAction } from '../../store/bill/billPaymentReducer';

const BillCxCNotify = props => {

    const { authorized, auth } = useAuthorization([resources.closeBill, dataAccess.access ]);
    const dispatch = useDispatch();   

    const { bill, onSave } = props;

    const confirmarPago = (e) => {
        let result = confirm("<i>Estas seguro de confirmar el pago?</i>", "Confirmar pago");
        result.then((dialogResult) => {
            
            if(dialogResult)
            {
                http(`bill/${bill.id}/payoff`).asGet().then(resp => {
                    //onSave()
                    let random = Math.random();

                    dispatch(billPaymentAction({ random }));
                });
            }

        });
    }

    const total  = bill.receipts.reduce((actual, nuevo) => {
        return actual + nuevo.amount;
    },0);

    const verFactura = () => {
        dispatch(billNotifyDialogAction({ open : true, id : bill.id }));
    }

    const pagado = total == bill.total;
    const pendiente = bill.total - total;

    const viewButtonCancel = auth.toCreate && pagado;

    const ultimoRegistro = bill.receipts.find(x => x.id == bill.ultimoRegistroId);

    return (
        <div>
            <div className="bill-bills">
                <div className={pagado ? 'bill-status bill-status-pagado' : 'bill-status bill-status-pendiente'}></div>
                <div className="bill-content">
                    <div className="bill-row">
                        <div className="text-bold">{formatDate(bill.date)}</div>
                        <div className="col-id-factura">{formatId(bill.numberBill)}</div>
                    </div>
                    <div className="bill-row">
                        <div>{bill.name}</div>
                        <div>{bill.category}</div>
                    </div>                   
                    <div className="bill-row">
                        <div>{ultimoRegistro && formatDate(ultimoRegistro.createAt)}</div>
                        <div>{ultimoRegistro && formatToMoney(ultimoRegistro.amount)}</div>
                        <div className={bill.mora < 0 && !pagado ? "text-bold text-danger" : "text-bold"}>
                            {!pagado ? `Mora : ${bill.mora}` : '0'}                            
                        </div> 
                    </div>
                    <div className="bill-row">
                        <div className="text-bold">{formatToMoney(bill.total)}</div>
                        <div className="">{formatToMoney(total)}</div>
                        <div className="col-id-pendiente">{formatToMoney(pendiente)}</div>
                    </div>
                    <div className="bill-footer">

                        <button 
                            className="dx-button dx-button-default dx-button-mode-outlined dx-widget btn-notify"
                            onClick={verFactura}
                            >
                                Ver
                        </button>
                                  
                        {viewButtonCancel && <button 
                            className="dx-button dx-button-success dx-button-mode-outlined dx-widget btn-notify"
                            onClick={confirmarPago}
                            >
                                Confirmar pago
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BillCxCNotify;
